import { globalApi as api } from '../../api';

// export const uploadUnitMaster = async (fileData,id) => {
//   try {
//     const token = sessionStorage.getItem('token');
//     const selectedClientID = sessionStorage.getItem('selectedClient')
//     const formData = new FormData();
//     formData.append('file', fileData);
//     const response = await api.post(`/upload_unit_master`, formData, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'multipart/form-data'
//       },
//       params:{
//         'selectedClientID' : id
//       }
//     });
//     return response.data;
//   } catch (error) {
//     throw error.response ? error.response.data.error : error.message;
//   }
// };



export const uploadUnitMaster = async (fileData,id) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const response = await api.post('/upload_unit_master', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      params:{
        'selectedClientID' : id
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};



export const fetchUnits = async (ClientID) => {
  try {
    const response = await api.get(`/units/${ClientID}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const updateUnit = async (id, unitData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/units/${id}`, unitData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const deleteUnit = async (id) => {
  try {
    const response = await api.delete(`/units/${id}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
export const multiDeleteClientUnits = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/delete_multipleClientUnits', ids, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const unitMasterDataInput = async (UnitDataInput) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/unit_single_entry', UnitDataInput, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const fetchAllUnits = async () => {
  try {
    const response = await api.get(`/units`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};


export const getUnitImportantBackup = async (current_month) => {
  const token = sessionStorage.getItem('token');
  const response = await api.get(`/get_units/${current_month}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};